import {Box, Button, Divider, InputAdornment, Stack, TextField, Typography} from "@mui/material";
import {
  IconChartArea,
  IconHeadphones,
  IconLanguage,
  IconSettingsAutomation,
  IconUser,
  IconPhone,
  IconMail,
  IconBuilding,
  IconMessage,
  IconSend
} from "@tabler/icons-react";
import {useState} from "react";
import {toast} from "react-toastify";
import axios from "axios";

export const TechnicalAndDemo = () => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    company: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phoneNumber || !formData.email || !formData.message) {
      toast.error("Please fill in all required fields");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    const to = "kiril.ristov@ireason.mk";
    const subject = encodeURIComponent("Contact Us – BlockFlow");
    const body = encodeURIComponent(
      `Name: ${formData.name}
Phone: ${formData.phoneNumber}
Company: ${formData.company || "-"}
    
Message:
${formData.message}`
    );

    const mailtoLink = `mailto:${to}?subject=${subject}&body=${body}`;

    window.location.href = mailtoLink;

    // toast.success("Your email client has been opened ✉️");
  };


  return (
    <Stack
      id={"contact-us"}
      direction={"row"} gap={{xs: 2, md: 6}}
      useFlexGap flexWrap={"wrap"}
      justifyContent={"space-evenly"}
      alignItems={"center"}
      sx={{px: {xs: 2, md: 6}, py: {xs: 4, md: 10}, minHeight: "100dvh"}}
    >
      <Stack direction={"column"} alignItems={"center"}>
        <Stack direction={"column"} gap={{xs: 2, md: 4}} maxWidth={"sm"}>
          <Typography fontSize={{xs: "1.2em", md: "1.6em"}} fontWeight={600} color={"secondary"}
                      sx={{width: "100%"}} align={"center"}>
            Powering the Future of Contact Centers
          </Typography>
          <Divider sx={{width: "90%", mx: "auto"}}/>
          <Stack direction={"row"} gap={{xs: 2, md: 4}} alignItems={"center"}>
            <Box sx={{color: "primary.dark"}}>
              <IconLanguage size={30}/>
            </Box>
            <Box>

              <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Multilingual & 24/7</Typography>
              <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em"}}>
                {"Handle calls in multiple languages with zero downtime—just like a global team."}
              </Typography>
            </Box>
          </Stack>
          <Stack direction={"row"} gap={{xs: 2, md: 4}} alignItems={"center"}>
            <Box sx={{color: "primary.dark"}}>
              <IconChartArea size={30}/>
            </Box>
            <Box>
              <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Real-Time Analytics
                Dashboard</Typography>
              <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em"}}>
                {"Monitor call resolution rates, customer sentiment, and agent workload in live dashboards."}
              </Typography>
            </Box>
          </Stack>
          <Stack direction={"row"} gap={{xs: 2, md: 4}} alignItems={"center"}>
            <Box sx={{color: "primary.dark"}}>
              <IconSettingsAutomation size={30}/>
            </Box>
            <Box>
              <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Customizable Workflows</Typography>
              <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em"}}>
                {"Tailor scripts, escalation paths, and branding to your needs."}
              </Typography>
            </Box>
          </Stack>
          <Stack direction={"row"} gap={{xs: 2, md: 4}} alignItems={"center"}>
            <Box sx={{color: "primary.dark"}}>
              <IconHeadphones size={30}/>
            </Box>
            <Box>
              <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Seamless Human Handoff</Typography>
              <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em"}}>
                {"Escalates complex issues with full context to agents."}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Stack>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          flex: 1,
          maxWidth: "500px",
          minWidth: "300px",
          px: {xs: 2, md: 3},
          py: 3,
          // borderRadius: 3,
          // boxShadow: 3,
          bgcolor: "background.paper"
        }}
      >
        {/*<Typography variant="h5" fontWeight={600} mb={3} align="center" color="primary">*/}
        {/*  Contact Us*/}
        {/*</Typography>*/}

        <Stack spacing={2.5}>
          <Stack direction={"row"} spacing={2.5}>
            <TextField
              label="Name"
              required
              fullWidth
              value={formData.name}
              onChange={handleInputChange("name")}
              placeholder="Your full name"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconUser size={20} />
                  </InputAdornment>
                )
              }}
            />

            <TextField
              label="Phone Number"
              required
              fullWidth
              type="tel"
              value={formData.phoneNumber}
              onChange={handleInputChange("phoneNumber")}
              placeholder="+1 234 567 8900"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconPhone size={20} />
                  </InputAdornment>
                )
              }}
            />
          </Stack>

          <TextField
            label="Email"
            required
            fullWidth
            type="email"
            value={formData.email}
            onChange={handleInputChange("email")}
            placeholder="your.email@example.com"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconMail size={20} />
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="Company (Optional)"
            fullWidth
            value={formData.company}
            onChange={handleInputChange("company")}
            placeholder="Your company name"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconBuilding size={20} />
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="Message"
            required
            fullWidth
            multiline
            rows={4}
            value={formData.message}
            onChange={handleInputChange("message")}
            placeholder="Tell us how we can help you..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" sx={{ alignSelf: "flex-start", mt: 1.5 }}>
                  <IconMessage size={20} />
                </InputAdornment>
              )
            }}
          />

          <Button
            type="submit"
            variant="contained"
            color={"secondary"}
            size="large"
            disabled={loading}
            startIcon={<IconSend size={20} />}
            sx={{
              mt: 2,
              borderRadius: 2,
              py: 1.5,
              fontSize: "1em",
              fontWeight: 600
            }}
          >
            {loading ? "Sending..." : "Send Message"}
          </Button>
        </Stack>
      </Box>

    </Stack>
  )
}